import { createContext, useContext } from "react";

export interface MessageFeedbackContextValue {
  /**
   * Submit a follow-up comment for an already-submitted rating.
   * The backend upserts, so this safely adds the comment to the existing record.
   *
   * When `messageId` is null (stream didn't include a separate message ID),
   * the provider resolves it by fetching the chat and matching the last
   * assistant message.
   */
  submitComment: (
    chatId: string,
    messageId: string | null,
    comment: string,
    rating: "positive" | "negative",
  ) => void;

  /**
   * Submit source-level feedback (thumbs up/down on a specific chunk).
   * When `messageId` is null the provider resolves it the same way as
   * `submitComment`.
   */
  submitSourceFeedback: (
    chatId: string,
    messageId: string | null,
    chunkId: string,
    rating: "positive" | "negative",
  ) => void;
}

export const MessageFeedbackContext =
  createContext<MessageFeedbackContextValue | null>(null);

export function useMessageFeedback(): MessageFeedbackContextValue | null {
  return useContext(MessageFeedbackContext);
}
